import apiClient from '@/utils/request'
import { IUserNoteResponse, IUserNotesPayload } from '@/interfaces/userNotes'
import { nestedQueryFormatter } from '@/utils/query'

export const fetchItems = async (): Promise<IUserNoteResponse> => {
  const params = nestedQueryFormatter('sorter', {
    direction: 'desc',
    field: 'created_at'
  })
  const response = await apiClient.get<IUserNoteResponse>('/user_notes', {
    params
  })
  return response.data
}

export const createItem = async (
  params: IUserNotesPayload
): Promise<IUserNoteResponse> => {
  const response = await apiClient.post<IUserNoteResponse>(
    '/user_notes',
    params
  )
  return response.data
}
